module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_blue_hover.32cb8a8e.svg";